<template>
    <v-app>
        <v-layout pt-2 row wrap v-if="singlePostReady">
            <v-flex xs12 sm12 md5>
                <v-card flat height="100%">
                    <v-btn @click="$router.go(-1)" flat small v-if="previousRoute === 'sentiment'">
                        <v-icon left small>chevron_left</v-icon>
                        <span class="text-capitalize font-weight-medium body-2">Back</span>
                    </v-btn>
                    <div style="display:flex;" class="align-center pa-3">
                        <v-avatar size="60">
                                <img :src="'//graph.facebook.com/'+monitorSinglePost.from.id+'/picture?width=60'" alt>
                            </v-avatar>
                        <div class="pa-2">
                            <a
                                    :href="monitorSinglePost.permalink_url"
                                    class="d-block zawgyi subheading font-weight-medium"
                                    style="text-decoration: none; color:#000;"
                                    target="_blank"
                            >
                                {{monitorSinglePost.from.name}}
                            </a>
                            <span class="caption description--color">
                                {{monitorSinglePost.created_time | fromNow }}
                                ( {{monitorSinglePost.created_time | formatDate}} )
                            </span>
                        </div>
                        <div style="flex: 0 0 15%" class="ml-auto text-xs-right">
                            <v-switch
                                    :disabled="isStatusUpdated"
                                    color="bindezcolor"
                                    v-model="monitorSinglePost.relevance"
                                    @change="togglePostStatus"
                            >
                                <template slot="label">
                                <span
                                        :class="[{ 'watch' : !isStatusUpdated && monitorSinglePost.relevance }, 'font-weight-bold', 'caption']"
                                >
                                    {{( !isStatusUpdated && monitorSinglePost.relevance) ? 'Watched' : 'Unwatch'}}
                                </span>
                                </template>
                            </v-switch>
                        </div>
                    </div>
                    <div class="px-3">
                        <v-img
                                :src="monitorSinglePost.picture"
                                aspect-ratio="1"
                                max-height="350px"
                                width="100%"
                        />
                    </div>
                    <div class="px-3">
                        <p
                                :class="{'full-height':fullHeight}"
                                class="zawgyi caption"
                                style="overflow:hidden; line-height: 2; word-break:break-all"
                                :inner-html.prop="monitorSinglePost.message | highlightPost(monitorSinglePost.tagged) | fromUnicodeToZawgyi"
                        >
                        </p>
                        <p
                                @click="seeMore"
                                class="mb-0"
                                style="cursor:pointer; color:var(--bindez-green-color);"
                        >
                            {{ fullHeight ? 'See More' : 'See Less'}}
                        </p>
                    </div>
                    <AppSearchComponent
                            :item-per-page="10"
                            :list-items="monitorSinglePost.tagged"
                            :ready="singlePostReady"
                            search-by="tag"
                    >
                        <h3 slot="title" class="body-2 font-weight-regular">Keywords</h3>
                        <template v-slot:list-item="{listView}">
                            <div class="chip-wrapper px-3">
                                <v-chip
                                        :key="chip"
                                        class="chip--custom-margin"
                                        color="bindezcolor"
                                        disabled
                                        label
                                        text-color="#fff" v-for="chip in listView"
                                >
                                    {{chip}}
                                </v-chip>
                            </div>
                        </template>
                    </AppSearchComponent>
                    <div class="px-3">
                        <v-divider class="mt-3"></v-divider>
                    </div>
                    <div class="pa-3 d-flex">
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{overallEngagement  | formatNumber}}
                            </span>
                            <span class="description--color caption">Overall Engagement</span>
                        </div>
                        <v-divider inset vertical></v-divider>
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{engagement.reachCount  | formatNumber}}
                            </span>
                            <span class="description--color caption">Est. Reached</span>
                        </div>                        
                        <v-divider inset vertical></v-divider>
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{engagement.impressionCount  | formatNumber}}
                            </span>
                            <span class="description--color caption">Est. Impression</span>
                        </div>
                    </div>
                    <div class="pa-3 d-flex">
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{monitorSinglePost.reaction_count.summary.total_count  | formatNumber}}
                            </span>
                            <span class="description--color caption">Reactions</span>
                        </div>
                        <v-divider inset vertical></v-divider>
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{monitorSinglePost.comments.summary.total_count | formatNumber}}
                            </span>
                            <span class="description--color caption">Comments</span>
                        </div>
                        <v-divider inset vertical></v-divider>
                        <div class="text-xs-center">
                            <span class="d-block font-weight-bold post-detail-info--medium">
                                {{monitorSinglePost.shares ? monitorSinglePost.shares.count : 0 | formatNumber}}
                            </span>
                            <span class="description--color caption">Shares</span>
                        </div>
                    </div>
                    <v-expansion-panel expand v-model="panel" class="elevation-0">
                        <v-expansion-panel-content

                                hide-actions
                        >
                            <div class="text-xs-center" slot="header">
                                <span class="mr-3" style="color:var(--bindez-green-color)">Details</span>
                                <v-icon color="bindezcolor" size="13">
                                    {{ panel[0] ? `fas fa-chevron-up` : `fas fa-chevron-down` }}
                                </v-icon>
                                <v-divider class="mt-3"></v-divider>
                            </div>
                            <v-card class="px-3">
                                <h3 class="body-2 font-weight-regular">Reactions</h3>
                                <div class="d-flex text-xs-center pt-3 pb-2">
                                    <TotalCategoriesCount
                                            class="reaction-item"
                                            :category="reaction"
                                            :category-color="{}"
                                            :is-reaction="true"
                                            :key="reaction.value"
                                            v-for="reaction in reactionsCount"
                                    ></TotalCategoriesCount>
                                </div>
                                <h3 class="body-2 font-weight-regular">Sentiments</h3>
                                <div class="py-3 chip-wrapper">
                                    <v-chip
                                            class="chip--custom-margin"
                                            :color="category"
                                            :key="category"
                                            disabled
                                            label
                                            outline
                                            v-for="{category, count} in monitorSinglePost.sentiment_summary"
                                    >
                                        <v-icon :color="category" class="mr-1" small>far fa-comments</v-icon>
                                        <span
                                                class="font-weight-bold"
                                                style="font-size:10px;"
                                        >
                                                {{count | abbrNumber}}
                                    </span>
                                    </v-chip>
                                </div>
                                <h3 class="body-2 font-weight-regular">Folders</h3>
                                <div class="d-flex pt-1 pb-3">
                                    <div class="text-xs-center">
                                        <span class="d-block post-detail-info--medium font-weight-bold">
                                            {{analyticCount.inboxCount | formatNumber }}
                                        </span>
                                        <span class="description--color caption">Inbox</span>
                                    </div>
                                    <v-divider inset vertical></v-divider>
                                    <div class="text-xs-center">
                                        <span class="d-block post-detail-info--medium font-weight-bold">
                                            {{analyticCount.trashCount | formatNumber }}
                                        </span>
                                        <span class="description--color caption">Trash</span>
                                    </div>
                                </div>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-card>
            </v-flex>
            <v-flex xs12 sm12 md7>
<!--                <v-layout column fill-height>-->
                <div style="display: flex; flex-direction: column; height: 100%;">

                    <v-flex pa-0>
                        <TagsFilter :notFoundSectionHeight="175" v-model="selectedTag" @filterByTags="filterByTags" :numOfTags="10" :tags="monitorSinglePost.custom_tags"></TagsFilter>
                    </v-flex>
                    <v-flex xs12 pa-0 pt-3>
                        <v-card flat height="100%">
                            <AppComments
                                    v-model="term"
                                    :isPostReadOnly="isPostReadOnly"
                                    :fitByCat="true"
                                    :commentsReady="monitorPostCommentsReady"
                                    :comments="monitorSinglePostComments"
                                    :commentsCount="monitorSinglePostCommentsCount"
                                    @searchCommentsByTerm="searchCommentsByTerm"
                                    @filterByCategory="filterByCategory"
                                    @paginate="paginate"
                            />
                            <div class="text-xs-center py-2">
                                    <AppBindezPagination
                                            v-if="monitorPostCommentsReady && monitorSinglePostCommentsCount > 0"
                                            ref="pagination"
                                            :length="pageLength"
                                            :per-page="perPage"
                                            v-model="page"
                                            circle
                                            @input="paginate"
                                            :next-skip-count="skipCount"
                                            color="bindezcolor"
                                            total-visible="9"
                                    >
                                    </AppBindezPagination>
                            </div>
                        </v-card>
                    </v-flex>
                </div>
<!--                </v-layout>-->
            </v-flex>
        </v-layout>
        <div class="text-xs-center" v-else>
            <Spinner/>
            <span class="font-weight-bold display-1 description--color">Loading...</span>
        </div>
    </v-app>
</template>

<script>
	import {mapActions, mapMutations, mapState} from "vuex";
	import moment from "moment";
	import Spinner from "@/components/Spinner";
	import AppBindezPagination from '@/components/AppBindezPagination';
	import AppComments from "@/components/AppComments";
	import _isEmpty from 'lodash/isEmpty';
	import _capitalize from 'lodash/capitalize';
	import AppSearchComponent from "../components/AppSearchComponent";
	import TotalCategoriesCount from "../components/TotalCategoriesCount";
	import TagsFilter from "@/components/Sentiment/TagsFilter";
	import {fromZawgyiToUnicode} from "../utils/font";

	export default {
		name: "PostDetail",
		props: {
			post_id: {
				required: true,
				type: String
			},
			monitor_uuid: {
				required: true,
				type: String
			}
		},
		data() {
			return {
				limit: 10,
				skip: 0,
				page: 1,
				skipCount: 5,
				perPage: 10,
				filterBy: undefined,
				monitorPostCommentsReady: false,
				singlePostReady: false,
				newTag: undefined,
				fullHeight: true,
				isStatusUpdated: false,
                panel:[true],
                selectedTag:{
					values:[],
                },
                singlePostCommentSearchTerm: "",
			}
		},
        //"static reaction data" to avoid making unnecessary state reactive
		reactions: ["like", "love", "haha", "sad", "wow", "angry"],

		computed: {
			...mapState("mention", [
                "pageFanCount",
				"monitorSinglePost",
				"monitorSinglePostComments",
				"monitorSinglePostCommentsCount",
			]),

			...mapState([
				"monitor",
				"selectedDate",
				"facebookSummary",
				"selectedComments",
				"previousRoute",
			]),

			...mapState("sentiment", [
				"commentSearchTerm"
			]),

			pageLength() {
				return Math.ceil(this.monitorSinglePostCommentsCount / 10);
			},

            overallEngagement(){
                let shareCount = this.monitorSinglePost.shares ? this.monitorSinglePost.shares.count : 0
                let reactionCount = this.monitorSinglePost.reaction_count.summary.total_count;
                let commentCount = this.monitorSinglePost.comments.summary.total_count;
                return  reactionCount + shareCount + commentCount;
            },

            engagement(){
                let page = this.pageFanCount;
                
                let followers = page.followers_count ? page.followers_count : 1;

                let shareCount = this.monitorSinglePost.shares ? this.monitorSinglePost.shares.count : 0
                let reactionCount = this.monitorSinglePost.reaction_count.summary.total_count;
                let commentCount = this.monitorSinglePost.comments.summary.total_count;
                
                let engagementCount =   reactionCount + shareCount + commentCount;
                let reachCount =  Math.ceil((shareCount + 1) * followers * 0.05)
                let impressionCount =  Math.ceil(((shareCount + 1) * followers * 0.05) * 1.5)

                return {engagementCount, reachCount, impressionCount};
            },

			analyticCount() {
				let inboxCount = [];
				let trashCount = 0;
				this.monitorSinglePost.sentiment_summary.forEach(({category, count}) => {
					category === 'other' ? trashCount = count : inboxCount.push(count);
				});
				inboxCount = inboxCount.reduce((acc, cur) => acc + cur, 0);
				return {inboxCount, trashCount};
			},

			reactionsCount() {
				return this.$options.reactions.map(reaction => {
					let {summary: {total_count}} = this.monitorSinglePost[`${reaction}_count`];
					let img = _capitalize(reaction);
					return {
						value: reaction,
						count: total_count,
						img: require(`@/assets/reactions/${img}.svg`)
					}
				});
			},

			isPostReadOnly() {
				return this.monitorSinglePost && !this.monitorSinglePost.relevance;
			},

            term:{
				get(){
					return this.singlePostCommentSearchTerm;
                },
                set(term){
					this.singlePostCommentSearchTerm = term;
                }
            }

		},
		methods: {
			...mapActions("mention", [
                "fetchPageFanCount",
				"fetchMonitorSinglePost",
				"fetchMonitorPostComments",
				"updatePostStatus",                
			]),

			...mapActions([
				"fetchMonitor",
				"fetchFacebookSummary",
				"createCommentTags"
			]),

			...mapMutations('mention', [
                "setPageFanCount",
				"setMonitorSinglePost",
			]),

			seeMore() {
				this.fullHeight = !this.fullHeight;
			},

			fetchPostComments() {
				let term = this.term && fromZawgyiToUnicode(this.term);
				this.monitorPostCommentsReady = false;
				this.$store.commit("mention/setMonitorSinglePostComments", []);
				let data = {
					category: this.filterBy || null,
					term: term || null,
					skip: this.skip,
				};
				data = this.selectedTag.values.length ? {...data, tags:this.selectedTag} : data;
				this.fetchMonitorPostComments({
					data,
                    post_id: this.post_id,
					monitor_uuid: this.monitor_uuid
				}).then(() => (this.monitorPostCommentsReady = true));
			},

			filterByCategory(value) {
				this.skip = 0;
				this.filterBy = value;
				this.page = 1;
				this.fetchPostComments();
			},

			paginate(page) {
				this.skip = page === 1 ? 0 : (page - 1) * 10;
				this.fetchPostComments();
			},

			searchCommentsByTerm() {
				this.page = 1;
				this.skip = 0;
				this.fetchPostComments()
			},

			togglePostStatus() {
				this.isStatusUpdated = true;
				this.updatePostStatus({
					post_id: this.post_id,
					monitor_uuid: this.monitor_uuid,
					relevant: this.monitorSinglePost.relevance
				})
					.then(_ => this.setMonitorSinglePost(this.monitorSinglePost))
					.finally(_ => this.isStatusUpdated = false);
			},

            filterByTags(){
				this.skip = 0;
				this.page = 1;
				this.fetchPostComments();
            }
		},

		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.singlePostReady = false;
				if (from.name === 'mention' || from.fullPath === '/') {
					vm.fetchMonitorSinglePost({post_id: vm.post_id, monitor_uuid: vm.monitor_uuid})
						.then(_ => {                            
                            let [pageId] =  vm.post_id.split("_");
							return Promise.all([                             
                                vm.fetchPageFanCount({monitor_uuid: vm.monitor_uuid, page_id : pageId}),
								vm.fetchFacebookSummary({monitor_uuid: vm.monitor_uuid, timerange: vm.selectedDate}),
								vm.fetchMonitorPostComments({post_id: vm.post_id, monitor_uuid: vm.monitor_uuid}),
							])
						})
						.finally(_ => {
							vm.singlePostReady = true;
							vm.monitorPostCommentsReady = true;
						})                    
				} else if (from.name === 'sentiment') {
					vm.singlePostReady = true;
					vm.monitorPostCommentsReady = true;
					vm.singlePostCommentSearchTerm = vm.commentSearchTerm;
					if ((vm.monitorSinglePostComments[0].post_id !== vm.monitorSinglePost.id) || _isEmpty(vm.monitorSinglePost)) {
						vm.singlePostReady = false;
						vm.fetchMonitorSinglePost({post_id: vm.post_id, monitor_uuid: vm.monitor_uuid})
							.then(() => {
								vm.singlePostReady = true;
							});
					}
				}
			})
		},

		filters: {
			fromNow(raw) {
				return moment(raw).fromNow();
				//return moment(raw, "YYYYMMDD").fromNow();
			},

			formatDate(raw) {
				return moment(raw).format("ddd, DD MMM YYYY [at] h:mm a");
			},
		},

		components: {
			TotalCategoriesCount,
			AppSearchComponent,
			Spinner,
			AppComments,
			AppBindezPagination,
            TagsFilter
		}
	};
</script>

<style scoped>
    .full-height{
        max-height: 200px;
    }

    .post-detail-info--medium{
        font-size: 18px;
    }

    .reaction-item:not(:last-child){
        border-right: 1px solid #efefef;
    }
</style>
